export const SUPPORTED_LOCALES = ["en-US"] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "en-US";

/**
 * Parses a comma-separated locale string from an environment variable and
 * returns only the values that are in SUPPORTED_LOCALES.
 * Returns the full SUPPORTED_LOCALES list when the raw value is absent or empty.
 *
 * Example: VITE_SUPPORTED_LOCALES="en-US,nl-BE" => ["en-US"] (nl-BE filtered out)
 */
export function parseSupportedLocales(raw: string | null | undefined): readonly SupportedLocale[] {
  if (!raw?.trim()) return SUPPORTED_LOCALES;

  const requested = raw.split(",").map((l) => l.trim());
  const filtered = SUPPORTED_LOCALES.filter((l) => requested.includes(l));
  return filtered.length > 0 ? filtered : SUPPORTED_LOCALES;
}
